import React from 'react';
import { Helmet } from 'react-helmet-async';
import Industries from '../components/Industries';

const breadcrumbSchema = {
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: [
    { '@type': 'ListItem', position: 1, name: 'Home', item: 'https://wayug.com/' },
    { '@type': 'ListItem', position: 2, name: 'Industries', item: 'https://wayug.com/industries' },
  ],
};

const IndustriesPage = () => {
  return (
    <div className="page-content subpage-content">
      <Helmet>
        <title>IT Services by Industry — Healthcare, Finance &amp; More | Wayug</title>
        <meta
          name="description"
          content="Custom IT solutions for healthcare, fintech, manufacturing, retail, government and education. Wayug Infotech delivers industry-compliant digital transformation across India."
        />
        <link rel="canonical" href="https://wayug.com/industries" />
        <meta property="og:title" content="IT Services by Industry — Healthcare, Finance &amp; More | Wayug" />
        <meta
          property="og:description"
          content="Sector-specific IT services for fintech, healthcare, e-commerce, manufacturing, government and education. HIPAA, ISO 27001 compliant platforms."
        />
        <meta property="og:url" content="https://wayug.com/industries" />
        <meta property="og:type" content="website" />
        <script type="application/ld+json">{JSON.stringify(breadcrumbSchema)}</script>
      </Helmet>
      <Industries />
    </div>
  );
};

export default IndustriesPage;
